import { CSSObject } from "@emotion/react";
import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

export const AssignModalZIndex = 14;

export const footerLayoutCss = (isCreateMode: boolean): CSSObject => {
  return {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      "flex-direction": isCreateMode ? "column-reverse" : "row",
    },
  };
};

export const secondaryBtnsCss = (isCreateMode: boolean): CSSObject => {
  return {
    display: "flex",
    flexDirection: "row",

    [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
      paddingTop: isCreateMode ? "1em" : 0,
      "> *": {
        flexGrow: "1",
      },
      button: {
        width: "95%",
        marginRight: "1em",
        justifyContent: "center",
      },
    },
    [breakpoint.downTo(constants.breakpoints.BreakpointNames.sm)]: {
      justifyContent: "space-between",
      marginRight: "16px",
      flexGrow: 1,
    },
  };
};

export const primaryBtnCss: CSSObject = {
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    justifyContent: "center",
    button: { width: "100%", "justify-content": "center" },
  },
};

export const draftButtonCss = {
  svg: {
    path: {
      strokeWidth: 2,
    },
  },
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    svg: { display: "none" },
  },
};
